import { Injectable } from "@angular/core";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/content-search/models/form-search-parameters.model";
import { SearchResultModel } from "apps-module/app/entry-modules/content-search/models/search-result.model";
import { ApiRequestDispatcherService } from "apps-module/app/shared-library/services/api/api-request-dispatcher.service";
import { Observable } from "rxjs";

@Injectable()
export class SearchService {
    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService
    ) {
    }

    public search(searchParams: FormSearchParametersModel): Observable<SearchResultModel> {
        return this._requestDispatcher.get<SearchResultModel>("/api/content-search/results",  {...searchParams});
    }
}
